import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getFacets,
  selectAll,
  clear,
  changeMultiFacetAndApplyIfLargeMedium
} from "../../state/modules/search";
import { getNewFacets } from "../../state/modules/featureToggles/selectors";
import { getFloor } from "../../state/modules/config/selectors";
import { FLOOR_DEFAULT } from "../../state/modules/config/constants";
import { getLocation } from "../../state/modules/router/selectors";
import {
  analyticsOpenRefinementType,
  analyticsCloseRefinementType
} from "../../state/modules/analytics/actions";
import HorizontalRefinements from "../../components/HorizontalRefinements";
import { getSwatches } from "../../state/modules/facet/selectors";
import { getColourEnrichments } from "../../state/modules/facet/actions";

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        changeMultiFacet: changeMultiFacetAndApplyIfLargeMedium,
        selectAll,
        clear,
        analyticsOpenRefinementType,
        analyticsCloseRefinementType
      },
      dispatch
    ),
    getColourEnrichments: () => dispatch(getColourEnrichments())
  };
}

function mapStateToProps(state) {
  return {
    facets: getFacets(state),
    newFacets: getNewFacets(state),
    query: getLocation(state).query,
    hasFloor: getFloor(state) !== FLOOR_DEFAULT,
    swatchesMap: getSwatches(state)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HorizontalRefinements);
